import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, PatientArrivalConfirmationAliases } from '../../codegen';
import BaseController from '../BaseController';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { BaseModalProps, FormAPI, ModalButton, ModalService, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ModalType } from '@philips-internal/oswald-ui-constants';
import { BrokerService, HttpResponse, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { Inject } from '@odinjs/odin';
import { changePatientData } from '../../interfaces/change-patient/change-patient-data';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';

@Controller({ component: PatientArrivalConfirmationAliases.LAYOUT_MAIN, fragment: FragmentNames.PATIENT_ARRIVAL_CONFIRMATION })
class PatientArrivalConfirmationController extends BaseController {

  @Inject(PatientArrivalConfirmationAliases.TEXT_ATENDIMENTO)
  private readonly encounterId!: TextAPI;

  @Inject(PatientArrivalConfirmationAliases.TEXT_DESTINO)
  private readonly destination!: TextAPI;

  @Inject(PatientArrivalConfirmationAliases.FORM_FIELDS)
  private readonly formFields!: FormAPI;

  @Inject(PatientArrivalConfirmationAliases.PANEL_LOADER)
  private readonly panelLoaderApi!: PanelAPI;

  @OnMount({ target: PatientArrivalConfirmationAliases.LAYOUT_MAIN })
  onMountInput(): void {
    this.mountInformationBar();
  }

  @OnClick({target: PatientArrivalConfirmationAliases.ARRIVAL_CONFIRM })
  async onClickConfirm(): Promise<void> {
    this.panelLoaderApi.setVisible(true);
    const nrSeqLocalPa: number = this.context.get('sector') as number;
    const { encounterId } = this.historyService.getCurrentRouteParams() as Record<string, number>;
    try {
      const resp = await this.generateArrival(nrSeqLocalPa, encounterId, 'N', 0, '');
      const responseBody = resp.body as { STATUS: string };
      if (responseBody.STATUS === 'QUESTIONAR') {
        const buttons: ModalButton[] = [];
        buttons.push({
          action: () => { applicationContext.popNavigationItem(); },
          title: 'Cancelar',
          type: ModalButtonType.CANCEL,
        });

        buttons.push({
          action: () => { this.showModalReason(); },
          title: 'Confirmar',
          type: ModalButtonType.SUCCESS,
        });

        const dialogParams: BaseModalProps = {
          closeable: false,
          dialogDescription: 'O setor ' + this.context.get('department') + ' não foi selecionado na saída do paciente para exame. Deseja continuar?',
          dockButtons: buttons,
          title: 'Motivo de chegada sem saída',
          type: ModalType.DIALOG,
        }
        ModalService.openDialog(dialogParams);
        return;
      }
      if (responseBody.STATUS === 'SUCESS3') {
        this.showModalSubmit('text.arrival_success');
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.panelLoaderApi.setVisible(false);
    }
  }

  @OnMount({ target: PatientArrivalConfirmationAliases.FORM_FIELDS })
  onMountLayout(): void {
    this.inputFieldValues();
  }

  @OnClick({ target: PatientArrivalConfirmationAliases.ARRIVAL_CANCEL })
  onButtonClick(): void {
    applicationContext.popNavigationItem();
  }

  private inputFieldValues(): void {
    BrokerService.publishToTopic('setInformationBarData', this.context);
    BrokerService.publishToTopic('setChangeData', this.context);
    const { encounterId } = this.historyService.getCurrentRouteParams() as Record<string, string>;
    this.destination.setValue(this.context.get('department') as string);
    this.encounterId.setValue(encounterId);
    this.formFields.setLoading(false);
  }

  private showModalSubmit(text: string): void {
    ToastMsgUtils.toastSucessMessage('msg.success', text);
    applicationContext.popNavigationItem();
  }

  private async generateArrival(nrSeqLocalPa: number, encounterId: number, generate: string, reasonCode: number, justification: string): Promise<HttpResponse<unknown>> {
    const parameters = {
      departmentEncounter: nrSeqLocalPa,
      encounterId: encounterId,
      generate: generate,
      justification: justification,
      reasonCode: reasonCode,
    };
    return HttpService.get(
      Endpoint.GENERATE_TRANSFER_CONFIRMATION,
      parameters
    );
  }

  private showModalReason(): void {
    const buttons: ModalButton[] = [];
    buttons.push({
      action: () => { applicationContext.popNavigationItem(); },
      title: 'Cancelar',
      type: ModalButtonType.CANCEL,
    });

    const dialogModal: BaseModalProps = {
      closeable: false,
      dockButtons: buttons,
      focusOnOpen: true,
      fragment: FragmentNames.INFORM_REASON_ARRIVAL,
      id: FragmentNames.INFORM_REASON_ARRIVAL,
      onBeforeClose: () => this.dialogModalConfirm(FragmentNames.INFORM_REASON_ARRIVAL),
      title: 'Motivo de chegada sem saida',
      type: ModalType.DIALOG,
    };
    changePatientData.sector = this.context.get('sector') as string;
    ModalService.openDialog(dialogModal);
  }

  private dialogModalConfirm(id: string): void {
    ModalService.close(id);
    ModalService.close('dialog-modal-service');
  }

  private mountInformationBar(): void {
    const { patientId, encounterId } =
      this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    InformationBarUtils.allowInfo = true;
    this.context.set({
      encounterId,
      patientId,
    });
  }
}

export default PatientArrivalConfirmationController;
